import { useOfferings } from '@/data/offering';
import { currencyFormat, formatMinutesToHours } from '@/helpers/stringHelpers';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Edit } from 'lucide-react';

const ListOfferingsForSettings = ({ coachActivityId }) => {
  const offerings = useOfferings({ coachActivityId });

  if (offerings.isLoading && !offerings.data) {
    return null;
  }

  return (
    <div>
      <div className="flex items-center justify-between my-2">
        <h5 className="text-sm font-medium text-muted-foreground">Offerings</h5>
        <Link to={`/offering?coachActivityId=${coachActivityId}`}>
          <Button variant="ghost" size="sm" className="h-8 px-2">
            <Edit className="h-3.5 w-3.5 mr-1" />
            Edit
          </Button>
        </Link>
      </div>
      {offerings.data.query.length === 0 && (
        <p className="text-sm text-muted-foreground text-center">
          No offerings set.
        </p>
      )}
      {offerings.data.query.length > 0 && (
        <ul className="text-sm space-y-2">
          {offerings.data.query.map((offeringId) => {
            const offering = offerings.data.content[offeringId];
            return (
              <li
                key={offeringId}
                className="flex justify-between items-center"
              >
                <span>{offering.name}</span>
                <span className="text-muted-foreground">
                  {currencyFormat(offering.pricePerClient)} /{' '}
                  {formatMinutesToHours(offering.length)} hrs
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default ListOfferingsForSettings;
